import BigNumber from "bignumber.js";

interface IOrderWithSummary
{
  totalPrice: string;
  totalTax: string;
  totalShippingPrice: string;
}

export function calculateSummaryTotal(order: IOrderWithSummary) : BigNumber
{
  const orderTotalPrice = new BigNumber(order.totalPrice);
  const orderTotalShipping = new BigNumber(order.totalShippingPrice);
  const orderTotalTax = new BigNumber(order.totalTax);
  const orderTotal = orderTotalPrice.plus(orderTotalShipping).plus(orderTotalTax);

  return orderTotal;
}

export default {
  calculateSummaryTotal
}